import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'au-priority-level',
	templateUrl: './au-priority-level.component.html',
	styleUrls: ['./au-priority-level.component.scss'],
	imports: [CommonModule, NgxTolgeeModule],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuPriorityLevelComponent {
	@Input() set level(value) {
		if (value === null || value === undefined) {
			return;
		}

		this.levelValue = value;
		this.array = Array(parseInt(value, 10));

		if (
			parseInt(value, 10) > Object.keys(this.colorsMap).length ||
			!this.colorsMap[this.levelValue]
		) {
			this.levelValue = Object.keys(this.colorsMap)[0];
			throw new Error(
				`There is only ${
					Object.keys(this.colorsMap).length
				} levels. But got ${value}. Wrong!`
			);
		}
	}

	@Input() showPriorityText = false;

	@Input() fallbackText = 'No priority';

	levelValue: string;
	array: void[];

	colorsMap = {
		0: { colors: '', text: 'no_priority' },
		1: { color: '#FFC700', text: 'low' },
		2: { color: '#FF8E26', text: 'medium' },
		3: { color: '#FF4D26', text: 'high' },
	};
}
